import { render } from "./BrAccordion.vue?vue&type=template&id=7e570e1c&scoped=true"
import script from "./BrAccordion.vue?vue&type=script&lang=js"
export * from "./BrAccordion.vue?vue&type=script&lang=js"

import "./BrAccordion.vue?vue&type=style&index=0&id=7e570e1c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e570e1c"]])

export default __exports__